import { connect } from 'react-redux'
import AddressComponent from '../components'
import { fetchAddress, fetchAllCountries, fetchAllStates } from '../actions/ApiReqest'
import { getMyProfileInfo } from '../../MyProfile/actions/apiRequest'

const mapStateToProps = (state) => ({
  addressList: state.address.list,
  mode: state.address.mode,
  merchantCanonicalName: state.merchant.canonical_name,
  merchantCountry: state.merchant.home_country,
})

const mapDispatchToProps = (dispatch) => ({
  fetchAddress: () => {
    dispatch(fetchAddress())
    dispatch(getMyProfileInfo())
  },
  fetchAllCountries: () => dispatch(fetchAllCountries()),
  fetchAllStates: (country) => dispatch(fetchAllStates(country)),
})

const Address = connect(mapStateToProps, mapDispatchToProps)(AddressComponent)

export default Address
